import { useQuery } from '@tanstack/react-query';
import type { UsageMetricRow } from '../aggregate';

export function useUsageMetrics(includeInternal: boolean) {
  const { data, isLoading, isError, error } = useQuery<UsageMetricRow[]>({
    queryKey: ['admin', 'usage-metrics', { include_internal: includeInternal }],
  });

  return { rows: data, isLoading, isError, error };
}
